import React from "react";
import { Helmet } from "react-helmet-async";
import "./SEO.css";

import SEOHeroImg from "../assets/seo-hero.jpeg";


const SEO = () => {

  const handleCTAClick = () => {
    if (window.gtag) {
      window.gtag("event", "click", {
        event_category: "CTA",
        event_label: "WhatsApp CTA",
        value: 1,
      });
    }
  };

  return (
    <>

      {/* SEO */}
      <Helmet>
        <title>
          SEO Services in Kenya | SEO Company in Kenya | Satima Technova Solutions
        </title>

        <link
          rel="canonical"
          href="https://satimatechnova.co.ke/seo-services-kenya/"
        />

        <meta
          name="description"
          content="Professional SEO services in Kenya that improve Google visibility, attract the right audience, and help businesses grow through strategic search engine optimization."
        />

        <meta
          name="keywords"
          content="SEO services Kenya, SEO company Kenya, SEO services Nairobi, search engine optimization Kenya, local SEO Kenya, Google ranking Kenya, SEO consultant Kenya, SEO for SMEs Kenya, Satima Technova Solutions"
        />

        <meta
          name="author"
          content="Satima Technova"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="SEO Services in Kenya | Satima Technova Solutions"
        />

        <meta
          property="og:description"
          content="Strategic SEO services that improve search visibility, attract the right audience, and create sustainable business growth in Kenya."
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:url"
          content="https://satimatechnova.co.ke/seo-services-kenya/"
        />


        <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How long does SEO take to show results?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "SEO is a long term process and results vary depending on your website, competition, industry, authority, technical foundation, and the search opportunities being targeted. Consistent optimisation and content can create stronger results over time."
        }
      },
      {
        "@type": "Question",
        "name": "Can SEO help a small business in Kenya?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. SEO can be particularly valuable for small businesses because it can help them become visible when potential customers are actively searching for relevant products or services."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide Local SEO?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local SEO can include Google Business Profile optimisation, local keyword strategy, website optimisation, and improvements to your local search presence."
        }
      },
      {
        "@type": "Question",
        "name": "Is SEO better than Google Ads?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "SEO and Google Ads serve different purposes. SEO can build long term organic visibility while Google Ads can provide immediate paid visibility. Depending on your goals, the two can work together."
        }
      },
      {
        "@type": "Question",
        "name": "Can SEO improve my existing website?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. An existing website can often be improved through technical optimisation, better page structure, keyword targeting, content improvements, internal linking, and stronger local signals."
        }
      }
    ]
  })}
</script>
      </Helmet>



      {/* HERO */}
<section
  className="seo-hero-section"
  style={{
    backgroundImage: `url(${SEOHeroImg})`,
  }}
>
  <div className="seo-hero-overlay">
    <div className="seo-hero-wrapper">
      <div className="seo-hero-text">

        {/* Hidden SEO Heading */}
        <h1 className="seo-hidden-heading">
          SEO Services in Kenya That Improve Your Google Visibility
        </h1>

        <div className="seo-hero-content">
          <span className="seo-hero-tag">
            SEO SERVICES
          </span>

          <h2>
            Get Found.
            <br />
            <span>Get Chosen.</span>
          </h2>

          <p className="seo-hero-intro">
            Strategic SEO designed to improve your visibility,
            attract the right audience, and create sustainable
            business growth through search.
          </p>
        </div>

        <a
          href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I%E2%80%99m%20interested%20in%20your%20SEO%20services."
          target="_blank"
          rel="noopener noreferrer"
          className="seo-hero-cta"
          onClick={handleCTAClick}
        >
          Start Your SEO Strategy
        </a>

        <div className="seo-trust-points">
          <p>✓ Technical SEO</p>
          <p>✓ Local SEO</p>
          <p>✓ SEO Content</p>
        </div>

      </div>
    </div>
  </div>
</section>


      {/* THE SEO PROBLEM */}
      <section className="seo-problem-section">
        <div className="seo-problem-container">

          <div className="seo-problem-header">
            <span className="seo-problem-label">
              THE SEO PROBLEM
            </span>

            <h2>
              Being Online Doesn't Mean
              <br />
              Being Discoverable.
            </h2>

            <p>
              Your business can have a great website and still remain
              invisible to the people searching for what you offer.
              SEO helps close that gap.
            </p>
          </div>

          <div className="seo-problem-card">
            <div className="seo-problem-accent"></div>

            <div className="seo-problem-content">

              <div className="seo-problem-statement">
                <span className="seo-problem-quote">“</span>

                <h3>
                  Visibility
                  <br />
                  <span>Is Not Accidental.</span>
                </h3>
              </div>

              <div className="seo-problem-message">

                <p>
                  Search visibility comes from understanding how
                  people search, how search engines understand your
                  website, and what makes your business relevant.
                  Without that foundation, your website may struggle
                  to generate
                  <strong> consistent organic opportunities.</strong>
                </p>

                <div className="seo-problem-principles">

                  <div className="seo-problem-principle">
                    <span className="seo-problem-number">01</span>

                    <div>
                      <h4>Search Intent Matters</h4>

                      <p>
                        The right keywords are not simply popular.
                        They should reflect what your potential
                        customers are actually looking for.
                      </p>
                    </div>
                  </div>

                  <div className="seo-problem-principle">
                    <span className="seo-problem-number">02</span>

                    <div>
                      <h4>Your Website Needs Structure</h4>

                      <p>
                        Search engines need clear signals about your
                        pages, content, services, location, and the
                        value your business provides.
                      </p>
                    </div>
                  </div>

                  <div className="seo-problem-principle">
                    <span className="seo-problem-number">03</span>

                    <div>
                      <h4>SEO Takes Consistency</h4>

                      <p>
                        Sustainable search visibility comes from
                        continuous improvement rather than quick
                        fixes or one-time optimisation.
                      </p>
                    </div>
                  </div>

                </div>

                <div className="seo-problem-highlight">
                  <span className="seo-problem-highlight-line"></span>

                  <p>
                    Your business doesn't need
                    <strong> more website traffic.</strong>
                    It needs the right people finding you.
                  </p>
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>


      {/* WHAT WE DO */}
      <section className="seo-services-section">
        <div className="seo-services-container">

          <div className="seo-services-header">
            <span className="seo-services-label">
              WHAT WE DO
            </span>

            <h2>
              SEO Built Around
              <br />
              Your Business.
            </h2>

            <p>
              We focus on the areas that influence how your business
              is discovered, understood, and considered through search.
            </p>
          </div>

          <div className="seo-services-list">

            <div className="seo-services-item">
              <div className="seo-services-number">01</div>

              <div className="seo-services-main">
                <div className="seo-services-title">
                  <h3>Technical SEO</h3>
                  <span>Foundation</span>
                </div>

                <p>
                  We improve the technical structure of your website
                  so search engines can crawl, understand, and index
                  your pages effectively.
                </p>
              </div>
            </div>

            <div className="seo-services-item">
              <div className="seo-services-number">02</div>

              <div className="seo-services-main">
                <div className="seo-services-title">
                  <h3>On Page SEO</h3>
                  <span>Relevance</span>
                </div>

                <p>
                  We optimise page structure, headings, titles,
                  descriptions, internal links, and content around
                  meaningful search opportunities.
                </p>
              </div>
            </div>

            <div className="seo-services-item">
              <div className="seo-services-number">03</div>

              <div className="seo-services-main">
                <div className="seo-services-title">
                  <h3>Local SEO</h3>
                  <span>Visibility</span>
                </div>

                <p>
                  We help businesses improve their visibility for
                  location based searches and strengthen their presence
                  across Google and local search results.
                </p>
              </div>
            </div>

            <div className="seo-services-item">
              <div className="seo-services-number">04</div>

              <div className="seo-services-main">
                <div className="seo-services-title">
                  <h3>Keyword Strategy</h3>
                  <span>Opportunity</span>
                </div>

                <p>
                  We identify relevant search terms based on your
                  audience, services, competition, and the opportunities
                  available in your market.
                </p>
              </div>
            </div>

            <div className="seo-services-item">
              <div className="seo-services-number">05</div>

              <div className="seo-services-main">
                <div className="seo-services-title">
                  <h3>SEO Content</h3>
                  <span>Authority</span>
                </div>

                <p>
                  We create useful content that answers real questions,
                  supports search visibility, and gives your audience
                  a reason to trust your business.
                </p>
              </div>
            </div>

          </div>

          <div className="seo-services-footer">
            <span className="seo-services-footer-line"></span>

            <p>
              Better visibility starts with
              <strong> better direction.</strong>
            </p>
          </div>

        </div>
      </section>


      {/* THE SATIMA APPROACH */}
      <section className="seo-approach-section">
        <div className="seo-approach-container">

          <div className="seo-approach-header">
            <span className="seo-approach-label">
              THE SATIMA APPROACH
            </span>

            <h2>
              SEO With
              <br />
              Direction.
            </h2>

            <p>
              We treat SEO as an ongoing business growth process,
              not simply a checklist of website changes.
            </p>
          </div>

          <div className="seo-approach-card">
            <div className="seo-approach-accent"></div>

            <div className="seo-approach-intro">
              <span className="seo-approach-small-label">
                FROM SEARCH TO GROWTH
              </span>

              <h3>
                A Better Way to Approach SEO.
              </h3>

              <p>
                We understand the opportunity first, build the right
                foundation, optimise what matters, and use performance
                to guide what happens next.
              </p>
            </div>

            <div className="seo-approach-process">

              <div className="seo-approach-step">
                <div className="seo-approach-step-top">
                  <span className="seo-approach-number">01</span>
                  <span className="seo-approach-connector"></span>
                </div>

                <div className="seo-approach-step-content">
                  <h4>Research</h4>

                  <p>
                    Your audience, keywords, competitors,
                    website, and search opportunities.
                  </p>
                </div>
              </div>

              <div className="seo-approach-step">
                <div className="seo-approach-step-top">
                  <span className="seo-approach-number">02</span>
                  <span className="seo-approach-connector"></span>
                </div>

                <div className="seo-approach-step-content">
                  <h4>Structure</h4>

                  <p>
                    The technical and content foundation
                    your website needs.
                  </p>
                </div>
              </div>

              <div className="seo-approach-step">
                <div className="seo-approach-step-top">
                  <span className="seo-approach-number">03</span>
                  <span className="seo-approach-connector"></span>
                </div>

                <div className="seo-approach-step-content">
                  <h4>Optimise</h4>

                  <p>
                    Pages, content, local visibility, and
                    search signals that support your goals.
                  </p>
                </div>
              </div>

              <div className="seo-approach-step">
                <div className="seo-approach-step-top">
                  <span className="seo-approach-number">04</span>
                </div>

                <div className="seo-approach-step-content">
                  <h4>Measure</h4>

                  <p>
                    Search performance, traffic, visibility,
                    and opportunities for improvement.
                  </p>
                </div>
              </div>

            </div>

            <div className="seo-approach-highlight">
              <span className="seo-approach-highlight-line"></span>

              <p>
                SEO is not about
                <strong> chasing rankings.</strong>
                It is about becoming easier to find when your
                customers are looking.
              </p>
            </div>

          </div>
        </div>
      </section>


      {/* WHY CHOOSE SATIMA */}
      <section className="seo-why-section">
        <div className="seo-why-container">

          <div className="seo-why-header">
            <span className="seo-why-label">
              WHY CHOOSE SATIMA
            </span>

            <h2>
              SEO Built Around
              <br />
              Your Business.
            </h2>

            <p>
              We combine search expertise with business understanding
              to build SEO strategies that have a clear purpose.
            </p>
          </div>

          <div className="seo-why-card">
            <div className="seo-why-accent"></div>

            <div className="seo-why-content">

              <div className="seo-why-statement">
                <span className="seo-why-quote">“</span>

                <h3>
                  More Than
                  <br />
                  <span>Search Rankings.</span>
                </h3>
              </div>

              <div className="seo-why-message">

                <p>
                  SEO should connect search visibility with the
                  bigger picture of your business.
                  <strong>
                    {" "}
                    We focus on meaningful opportunities,
                  </strong>
                  not vanity metrics that look good but do little
                  for your growth.
                </p>

                <div className="seo-why-principles">

                  <div className="seo-why-principle">
                    <span className="seo-why-number">01</span>

                    <div>
                      <h4>Strategy First</h4>

                      <p>
                        We begin with your business objectives,
                        audience, market, and the search opportunities
                        that matter most.
                      </p>
                    </div>
                  </div>

                  <div className="seo-why-principle">
                    <span className="seo-why-number">02</span>

                    <div>
                      <h4>Business Understanding</h4>

                      <p>
                        We look beyond keywords to understand what
                        your customers need and what should happen
                        after they find you.
                      </p>
                    </div>
                  </div>

                  <div className="seo-why-principle">
                    <span className="seo-why-number">03</span>

                    <div>
                      <h4>Measurable Improvement</h4>

                      <p>
                        We use performance data and search insights
                        to identify what is working and where to
                        improve.
                      </p>
                    </div>
                  </div>

                </div>

                <div className="seo-why-highlight">
                  <span className="seo-why-highlight-line"></span>

                  <p>
                    Good SEO is not about being visible to everyone.
                    It is about being visible to
                    <strong> the right people.</strong>
                  </p>
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>


      {/* LOCAL SEO */}
      <section className="seo-local-section">
        <div className="seo-local-container">

          <div className="seo-local-header">
            <span className="seo-local-label">
              LOCAL SEO
            </span>

            <h2>
              Be Visible Where
              <br />
              Local Customers Search.
            </h2>

            <p>
              For businesses serving specific locations, local search
              visibility can become one of the most valuable sources
              of qualified enquiries.
            </p>
          </div>

          <div className="seo-local-grid">

            <div className="seo-local-feature">
              <span className="seo-local-feature-number">01</span>

              <span className="seo-local-mini-label">
                GOOGLE BUSINESS PROFILE
              </span>

              <h3>
                Turn Local Searches
                <br />
                Into Opportunities.
              </h3>

              <p>
                We optimise your Google Business Profile and local
                search presence so potential customers can discover
                your business, understand what you offer, and take action.
              </p>
            </div>

            <div className="seo-local-list">

              <div className="seo-local-item">
                <span className="seo-local-number">02</span>

                <div>
                  <h3>Local Keywords</h3>

                  <p>
                    Target location based searches relevant to
                    your products, services, and customers.
                  </p>
                </div>
              </div>

              <div className="seo-local-item">
                <span className="seo-local-number">03</span>

                <div>
                  <h3>Business Information</h3>

                  <p>
                    Keep important business details clear and
                    consistent across your digital presence.
                  </p>
                </div>
              </div>

              <div className="seo-local-item">
                <span className="seo-local-number">04</span>

                <div>
                  <h3>Local Visibility</h3>

                  <p>
                    Strengthen the signals that help your business
                    appear in relevant local searches.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>


      {/* SEO CONTENT */}
      <section className="seo-content-section">
        <div className="seo-content-container">

          <div className="seo-content-header">
            <span className="seo-content-label">
              SEO CONTENT
            </span>

            <h2>
              Create Content
              <br />
              Search Engines Understand.
            </h2>

            <p>
              Useful content helps your business answer questions,
              demonstrate expertise, and create more opportunities
              to appear in relevant searches.
            </p>
          </div>

          <div className="seo-content-layout">

            <div className="seo-content-featured">
              <span className="seo-content-featured-number">
                01
              </span>

              <div className="seo-content-featured-content">
                <span className="seo-content-mini-label">
                  SEARCH + VALUE
                </span>

                <h3>
                  Content That
                  <br />
                  Serves a Purpose.
                </h3>

                <p>
                  We create search focused content that balances
                  SEO requirements with the needs of real people.
                </p>
              </div>

              <span className="seo-content-arrow">↗</span>
            </div>

            <div className="seo-content-list">

              <div className="seo-content-item">
                <span className="seo-content-number">02</span>

                <div className="seo-content-item-main">
                  <h3>Keyword Research</h3>

                  <p>
                    Identify the topics and search terms that
                    represent genuine opportunities.
                  </p>
                </div>

                <span className="seo-content-item-arrow">↗</span>
              </div>

              <div className="seo-content-item">
                <span className="seo-content-number">03</span>

                <div className="seo-content-item-main">
                  <h3>Blog Articles</h3>

                  <p>
                    Useful articles that educate your audience
                    while supporting your search strategy.
                  </p>
                </div>

                <span className="seo-content-item-arrow">↗</span>
              </div>

              <div className="seo-content-item">
                <span className="seo-content-number">04</span>

                <div className="seo-content-item-main">
                  <h3>Service Pages</h3>

                  <p>
                    Structured pages designed to communicate
                    relevance and guide visitors toward action.
                  </p>
                </div>

                <span className="seo-content-item-arrow">↗</span>
              </div>

              <div className="seo-content-item">
                <span className="seo-content-number">05</span>

                <div className="seo-content-item-main">
                  <h3>Search Intent</h3>

                  <p>
                    Content aligned with what people actually
                    want to know, compare, solve, or buy.
                  </p>
                </div>

                <span className="seo-content-item-arrow">↗</span>
              </div>

            </div>
          </div>

          <div className="seo-content-footer">
            <span className="seo-content-footer-line"></span>

            <p>
              Don't create content for search engines alone.
              <strong> Create value people want to find.</strong>
            </p>
          </div>

        </div>
      </section>


      {/* MEASUREMENT */}
      <section className="seo-measure-section">
        <div className="seo-measure-container">

          <div className="seo-measure-header">
            <span className="seo-measure-label">
              RESULTS & MEASUREMENT
            </span>

            <h2>
              SEO Should Become
              <br />
              More Intelligent Over Time.
            </h2>

            <p>
              Search performance gives us insight into what your
              audience responds to and where your next opportunities lie.
            </p>
          </div>

          <div className="seo-measure-card">
            <div className="seo-measure-accent"></div>

            <div className="seo-measure-content">

              <div className="seo-measure-statement">
                <span className="seo-measure-quote">“</span>

                <h3>
                  Measure.
                  <br />
                  <span>Learn. Improve.</span>
                </h3>
              </div>

              <div className="seo-measure-message">

                <p>
                  SEO is an ongoing process. We monitor meaningful
                  signals so decisions are based on evidence rather
                  than assumptions.
                </p>

                <div className="seo-measure-principles">

                  <div className="seo-measure-principle">
                    <span className="seo-measure-number">01</span>

                    <div>
                      <h4>Organic Visibility</h4>

                      <p>
                        Understand how your website is appearing
                        across relevant search opportunities.
                      </p>
                    </div>
                  </div>

                  <div className="seo-measure-principle">
                    <span className="seo-measure-number">02</span>

                    <div>
                      <h4>Search Traffic</h4>

                      <p>
                        Monitor organic traffic and identify the
                        pages and searches creating opportunities.
                      </p>
                    </div>
                  </div>

                  <div className="seo-measure-principle">
                    <span className="seo-measure-number">03</span>

                    <div>
                      <h4>Business Opportunities</h4>

                      <p>
                        Connect search performance with meaningful
                        actions such as enquiries, calls, and conversions.
                      </p>
                    </div>
                  </div>

                </div>

                <div className="seo-measure-highlight">
                  <span className="seo-measure-highlight-line"></span>

                  <p>
                    Rankings are useful.
                    <strong> Business impact matters more.</strong>
                  </p>
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>


      {/* FAQ */}
      <section className="seo-faq-section">
        <div className="seo-faq-container">

          <div className="seo-faq-header">
            <span className="seo-faq-label">
              FREQUENTLY ASKED QUESTIONS
            </span>

            <h2>
              SEO Questions,
              <br />
              Clearly Answered.
            </h2>

            <p>
              A few common questions businesses ask before
              investing in SEO.
            </p>
          </div>

          <div className="seo-faq-list">

            <details className="seo-faq-item">
              <summary>
                How long does SEO take to show results?
                <span>+</span>
              </summary>

              <p>
                SEO is a long term process and results vary depending
                on your website, competition, industry, authority,
                technical foundation, and the search opportunities
                being targeted. Consistent optimisation and content
                can create stronger results over time.
              </p>
            </details>

            <details className="seo-faq-item">
              <summary>
                Can SEO help a small business in Kenya?
                <span>+</span>
              </summary>

              <p>
                Yes. SEO can be particularly valuable for small
                businesses because it can help them become visible
                when potential customers are actively searching for
                relevant products or services.
              </p>
            </details>

            <details className="seo-faq-item">
              <summary>
                Do you provide Local SEO?
                <span>+</span>
            </summary>

              <p>
                Yes. Local SEO can include Google Business Profile
                optimisation, local keyword strategy, website
                optimisation, and improvements to your local search
                presence.
              </p>
            </details>

            <details className="seo-faq-item">
              <summary>
                Is SEO better than Google Ads?
                <span>+</span>
              </summary>

              <p>
                SEO and Google Ads serve different purposes. SEO can
                build long term organic visibility while Google Ads
                can provide immediate paid visibility. Depending on
                your goals, the two can work together.
              </p>
            </details>

            <details className="seo-faq-item">
              <summary>
                Can SEO improve my existing website?
                <span>+</span>
              </summary>

              <p>
                Yes. An existing website can often be improved through
                technical optimisation, better page structure,
                keyword targeting, content improvements, internal
                linking, and stronger local signals.
              </p>
            </details>

          </div>
        </div>
      </section>


      {/* FINAL CTA */}
      <section className="seo-final-cta-section">
        <div className="seo-final-cta-content">

          <span className="seo-final-cta-label">
            READY TO BE FOUND?
          </span>

          <h2>
            Make Search Work
            <br />
            For Your Business.
          </h2>

          <p>
            Build a stronger search presence with an SEO strategy
            connected to your website, audience, and business goals.
            From technical SEO and local search to content and
            performance, create a clearer path to discovery.
          </p>

          <div className="seo-final-cta-divider">
            <span></span>
          </div>

          <div className="seo-final-cta-points">
            <span>Strategy</span>
            <span>Visibility</span>
            <span>Authority</span>
            <span>Growth</span>
          </div>

          <a
            href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I%E2%80%99m%20interested%20in%20your%20SEO%20services."
            target="_blank"
            rel="noopener noreferrer"
            className="seo-final-cta-btn"
            onClick={handleCTAClick}
          >
            Start a Conversation
            <span>↗</span>
          </a>

          <p className="seo-final-cta-note">
            Strategic SEO services for businesses across Kenya
          </p>

        </div>
      </section>
    </>
  );
}

export default SEO;